import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginConfigService, LoginWrapperComponent } from 'gung-standard';

@Component({
    selector: 'tylo-login-wrapper',
    templateUrl: './tylo-login-wrapper.component.html',
    styleUrls: ['./tylo-login-wrapper.component.css'],
    standalone: false
})
export class TyloLoginWrapperComponent extends LoginWrapperComponent {

}
